import { useTranslation } from 'react-i18next';

export default function Products() {
  const { t } = useTranslation('home');
  const products = t('products.items', { returnObjects: true }) as Array<{
    id: string;
    tag: string;
    name: string;
    desc: string;
    specs: Array<{ label: string; value: string }>;
    price: string;
    image: string;
  }>;

  return (
    <section id="products" className="py-10 md:py-14 bg-white">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6">
            <div>
              <div className="text-xs font-medium text-slate-400 uppercase tracking-wider mb-2">{t('products.subtitle')}</div>
              <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-slate-900">
                {t('products.title')}
              </h2>
            </div>
            <p className="text-sm text-slate-500 max-w-md">
              {t('products.desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {products.map((product) => (
              <div
                key={product.id}
                className="bg-white border border-slate-200 rounded-lg overflow-hidden hover:border-orange-300 hover:shadow-sm transition-all group"
              >
                <div className="bg-slate-50 p-4 flex items-center justify-center">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-40 object-contain object-center group-hover:scale-105 transition-transform"
                  />
                </div>
                <div className="p-4">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs text-slate-400">{product.id}</span>
                    <span className="text-xs font-medium bg-slate-100 text-slate-600 px-2 py-0.5 rounded">{product.tag}</span>
                  </div>
                  <h3 className="text-base font-bold text-slate-900 mb-1">{product.name}</h3>
                  <p className="text-xs text-slate-500 mb-3 leading-relaxed">{product.desc}</p>
                  <ul className="space-y-1.5 mb-3">
                    {product.specs.map((spec) => (
                      <li key={spec.label} className="flex items-center justify-between text-xs">
                        <span className="text-slate-500">{spec.label}</span>
                        <span className="font-medium text-slate-900">{spec.value}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="pt-3 border-t border-slate-100">
                    <span className="text-lg font-bold text-slate-900">{product.price}</span>
                    <span className="text-xs text-slate-400 ml-1">{t('products.priceUnit')}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}